const changeHeaderColor = (color) => {
  return { type: "CHANGE_HEADER_COLOR", color: color };
};

const showBackButton = (screen) => {
  return { type: "SHOW_BACK_BUTTON", backScreen: screen };
};
const showBackButtonWithProps = (screen, props) => {
  return {
    type: "SHOW_BACK_BUTTON_WITH_PROPS",
    backScreen: screen,
    props: props,
  };
};
const showBackButtonWithFunction = (func) => {
  return {
    type: "SHOW_BACK_BUTTON_WITH_FUNCTION",
    function: func,
  };
};
const hideBackButton = () => {
  return { type: "HIDE_BACK_BUTTON" };
};
const showBottomNavigation = () => {
  return { type: "SHOW_BOTTOM_NAVIGATION" };
};
const hideBottomNavigation = () => {
  return { type: "HIDE_BOTTOM_NAVIGATION" };
};

export {
  changeHeaderColor,
  showBackButton,
  hideBackButton,
  showBottomNavigation,
  hideBottomNavigation,
  showBackButtonWithProps,
  showBackButtonWithFunction,
};
